// generated file, if you want to edit this file manually change the word "generated" to "manual"

import MaterialLink from '@mui/material/Link';
import { makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForLink = makeThemedStyles('BreadCrumb.Link', () => ({
  Link: {
    display: 'inline-flex',
    color: 'gray',
    fontSize: '12px'
  }
}));

type PropType = React.ComponentProps<typeof MaterialLink>;

export const Link: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForLink();

  // Pick classes from the theme if they are defined
  // const theme = useTheme();
  // const themeObj = (theme as any)?.qpr?.BreadCrumb?.Link
  const enabledClasses: { [key: string]: string } = {};
  const variants = ['Link'];
  Object.keys(styles || {})
    .filter(key => !variants.includes(key))
    .forEach(key => {
      if ((styles as any)[key]) {
        enabledClasses[key] = (styles as any)[key];
      }
    });

  /* eslint-disable */
  return (
    <MaterialLink
      {...props}
      classes={{
        root: styles.Link,
        ...enabledClasses
      }}
      className={clsx(styles.Link)}
      href={props.href}
    >
      {props?.children}
    </MaterialLink>
  );
};
export default Link;
